"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormattedMessage = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _translationsNamespaceContext = require("../contexts/TranslationsNamespaceProvider/translationsNamespaceContext");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Props for FormattedMessage with strict type-checking for translation values.
 *
 * @template T - The type of translations.
 */

/**
 * Renders a formatted internationalized message using the provided translation data.
 * @remarks Use in case of translation with HTML components instead of formatMessage accessible from useTranslations hook
 *
 * @template T The type of the translation data.
 *
 * @example
 * // Basic usage
 * <FormattedMessage<DefaultTranslations> id="greeting" />
 *
 * @description
 * This component is used for rendering internationalized messages. It combines the provided `id` with
 * the current translation namespace to retrieve the corresponding translation message.
 *
 * @see {@link FormattedMessageProps} for the available props and options.
 */
const FormattedMessage = ({
  id,
  ...props
}) => {
  const {
    namespace
  } = (0, _react.useContext)(_translationsNamespaceContext.translationsNamespaceContext);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
    id: `${namespace}:${String(id)}`,
    ...props
  });
};
exports.FormattedMessage = FormattedMessage;
//# sourceMappingURL=FormattedMessage.js.map